namespace Portico.Models.Enterprise {

	export interface IEnterprise {
		// intake data
		authentication: AuthenticationResponse;
		intakeLayout: IntakeLayout;
		layoutSection: LayoutSection;

		// list data
		diagnoses: Diagnosis[];
		ndcs: Ndc[];
		states: State[];
	}

	export class Enterprise implements IEnterprise {
		// intake data
		authentication: AuthenticationResponse;
		intakeLayout: IntakeLayout;
		layoutSection: LayoutSection;

		// list data
		diagnoses: Diagnosis[];
		ndcs: Ndc[];
		states: State[];

		constructor(obj?: IEnterprise) {
			this.authentication = null;
			this.intakeLayout = null;
			this.layoutSection = null;

			this.diagnoses = null;
			this.ndcs = null;
			this.states = null;

			if (obj) {
				if (obj.authentication) {
					this.authentication = new AuthenticationResponse(obj.authentication);
				}

				if (obj.intakeLayout) {
					this.intakeLayout = new IntakeLayout(obj.intakeLayout);
				}

				if (obj.layoutSection) {
					this.layoutSection = new LayoutSection(obj.layoutSection);
				}

				if (obj.diagnoses) {
					obj.diagnoses.forEach((diagnosis) => {
						this.diagnoses.push(new Diagnosis(diagnosis));
					});
				}

				if (obj.ndcs) {
					obj.ndcs.forEach((ndc) => {
						this.ndcs.push(new Ndc(ndc));
					});
				}

				if (obj.states) {
					obj.states.forEach((state) => {
						this.states.push(new State(state));
					});
				}
			}
        }
    }
}
